import { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

class ErrorBoundary extends Component {
  constructor(prop) {
    super(prop);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch() {
    this.setState({
      hasError: true,
    });
  }

  handleBack = () => {
    const { history } = this.props;
    this.setState({ hasError: false });
    history.push("/dashboard/pm-dashboard");
  };

  render() {
    const { hasError } = this.state;
    const { children, ...rest } = this.props;
    if (hasError) {
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default withRouter(ErrorBoundary);
